import IntersectionObserver from '@researchgate/react-intersection-observer';
import { ChangeHandler } from '@researchgate/react-intersection-observer/typings/types';
import React, { FC, memo, useState } from 'react';
import Slider from 'react-slick';

import LatestRequest from './LatestRequest/LatestRequest';
import { LatestRequests$Props, TLatestRequest } from './LatestRequests.helpers';
import './LatestRequests.scss';

const LatestRequests: FC<LatestRequests$Props> = (props) => {
  const [shouldLoadAvatars, setShouldLoadAvatars] = useState<boolean>(false);

  const requestsCount = props.requests.length;

  const sliderSettings = {
    infinite: false,
    speed: 500,
    slidesToShow: requestsCount < 3 ? requestsCount : 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const minItemsToSlide = 4;

  const handleIntersectionChange: ChangeHandler = (entry, unobserve): void => {
    if (entry.isIntersecting) {
      setShouldLoadAvatars(true);
      unobserve();
    }
  };

  const renderRequest = (request: TLatestRequest) => (
    <LatestRequest {...request} key={request.id} shouldLoadAvatars={shouldLoadAvatars} />
  );

  return (
    <IntersectionObserver onChange={handleIntersectionChange} rootMargin="0% 0% 15%">
      <div className="latestRequests">
        <div className="latestRequests__list">
          {requestsCount >= minItemsToSlide ? (
            <Slider {...sliderSettings}>{props.requests.map(renderRequest)}</Slider>
          ) : (
            props.requests.map(renderRequest)
          )}
        </div>
      </div>
    </IntersectionObserver>
  );
};

export default memo(LatestRequests);
